import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=b6740da2&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"
import style0 from "./Result.vue?vue&type=style&index=0&id=b6740da2&prod&lang=scss"
import style1 from "./Result.vue?vue&type=style&index=1&id=b6740da2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6740da2",
  null
  
)

export default component.exports